import script from "./FormularioMarcaVehiculo.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormularioMarcaVehiculo.vue?vue&type=script&setup=true&lang=ts"

import "./FormularioMarcaVehiculo.vue?vue&type=style&index=0&id=aa2e463e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa2e463e"]])

export default __exports__